<vnm-tile-card [header]="header" [subheader]="subheader">
  <p-listbox
    [options]="articles"
    optionLabel="title"
    [filter]="true"
    [filterPlaceHolder]="'support-faq.search-placeholder' | translate"
    (onChange)="openArticle($event)"
  >
    <ng-template pTemplate="header">
      <vnm-flex-container>
        <button
          pButton
          [label]="'support-faq.more-articles' | translate"
          icon="fa fa-fw fa-life-ring"
          class="p-button-secondary p-button-lg flex-1"
          (click)="openWindow(kbURL)"
        ></button>
        <button
          pButton
          [label]="'support-faq.contact-us' | translate"
          icon="fa fa-fw fa-envelope"
          class="p-button-secondary p-button-lg flex-1"
          (click)="openWindow('mailto:support@rapidlms.com')"
        ></button>
      </vnm-flex-container>
    </ng-template>
    <ng-template pTemplate="item" let-article>
      <div class="faq-article">
        <strong>{{ article.title }}</strong>
        <small>{{ article.description }}</small>
      </div>
    </ng-template>
  </p-listbox>
</vnm-tile-card>
